import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { DropdownFilterChipField, NakedButton, SearchField, UseFormReturnType } from '@frontend/design-system';

type FormConfig = {
  search: { type: 'text'; value: string };
  source: { type: 'checklist'; value: string[] };
};

type Props = {
  showSourceDropdown: boolean;
  showSearchbox: boolean;
  sourceOptions: { label: string; value: string }[];
  getFieldProps: UseFormReturnType<FormConfig, keyof FormConfig>['getFieldProps'];
};

export const Header = ({ showSearchbox, showSourceDropdown, sourceOptions, getFieldProps }: Props) => {
  const { t } = useTranslation('schedule-settings');

  return (
    <div css={headerStyles}>
      {showSourceDropdown && (
        <DropdownFilterChipField
          {...getFieldProps('source')}
          icon='data-sync'
          label={t('Source')}
          getCustomLabel={(items) => (items.length > 1 ? t('{{count}} Sources', { count: items.length }) : items[0])}
          showClearAll={false}
          onApply={({ close }) => {
            // TODO: Update filter values
            close();
          }}
        >
          {sourceOptions.map(({ label, value }) => (
            <DropdownFilterChipField.Option key={value} value={value}>
              {label}
            </DropdownFilterChipField.Option>
          ))}
        </DropdownFilterChipField>
      )}
      {showSearchbox && (
        <div css={{ width: 300, marginLeft: 'auto' }}>
          <SearchField {...getFieldProps('search')} />
        </div>
      )}
      {showSearchbox && (
        <NakedButton
          css={{ padding: theme.spacing(0, 3) }}
          onClick={() => {
            // TODO: Refetch List
          }}
        >
          <Icon name='update' css={{ marginLeft: theme.spacing(1) }} />
        </NakedButton>
      )}
    </div>
  );
};

const headerStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
});
